import React, { createContext, useState } from "react";
import { useLocation } from "@reach/router";
import Header from "./Header";
import Footer from "./Footer";
import ExternalLinkModal from "./ExternalLinkModal";

export interface LayoutProps {
  children: any;
}

type ModalContextValue = {
  isOpen: boolean;
  externalSiteUrl: string;
  openModal: (url: string) => void;
  closeModal: () => void;
}

// 外部サイトへの遷移確認モーダル
export const ModalContext = createContext<ModalContextValue | null>(null);

const Layout: React.FunctionComponent<LayoutProps> = (props) => {
  const { children } = props;
  const location = useLocation();
  const pageCategory = location.pathname.split('/')[1];
  const isTop = !pageCategory;
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [externalSiteUrl, setExternalSiteUrl] = useState('');

  // 外部サイトへの遷移確認モーダルを開く
  const openExternalLinkModal = (url: string) => {
    setIsOpenModal(true);
    setExternalSiteUrl(url);
  }

  // 外部サイトへの遷移確認モーダルを閉じる
  const closeExternalLinkModal = () => {
    setIsOpenModal(false);
  }

  return (
    <>
      <ModalContext.Provider value={{isOpen: isOpenModal, externalSiteUrl:externalSiteUrl, openModal: openExternalLinkModal , closeModal: closeExternalLinkModal}}>
        <Header isTransparent={!isTop}></Header>
        <main>{children}</main>
        <Footer></Footer>
        <ExternalLinkModal></ExternalLinkModal>
      </ModalContext.Provider>
    </>
  );
}

export default Layout;
